// Utility helpers for distinguishing images from videos
const VIDEO_EXTS = [".mp4", ".webm", ".mov", ".m4v", ".ogv"];

export function isVideoUrl(url) {
  if (!url) return false;
  const lower = String(url).toLowerCase().split("?")[0];
  return VIDEO_EXTS.some((ext) => lower.endsWith(ext)) || lower.includes("/video/");
}

export function mediaKind(url) {
  return isVideoUrl(url) ? "video" : "image";
}
